import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=471b4c3e&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=471b4c3e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b4c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471b4c3e')) {
      api.createRecord('471b4c3e', component.options)
    } else {
      api.reload('471b4c3e', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=471b4c3e&scoped=true&", function () {
      api.rerender('471b4c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2po2wJ9001te8/JS/comp/Paginate.vue"
export default component.exports